<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="editorials"
        :search="search"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
            />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="newItem()"
                  ><v-icon class="mr-2">mdi-plus-thick</v-icon
                  >{{ $t("button.newItem") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.name"
                            :label="$t('name')"
                            :rules="rules.char_required_max_130"
                            :counter="130"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.country"
                            :label="$t('table.country')"
                            :rules="rules.char_max_50"
                            :counter="50"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <v-checkbox
                            v-model="editedItem.hidden"
                            :label="$t('form.hidden')"
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          <v-checkbox
                            v-model="editedItem.featured"
                            :label="$t('form.featured')"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.featured="{ item }">
          <v-icon class="ml-6" v-if="item.featured" color="green">
            mdi-alert-octagram
          </v-icon>
          <v-icon v-else class="ml-6" color="grey">
            mdi-alert-octagram-outline
          </v-icon>
        </template>
        <template v-slot:item.hidden="{ item }">
          <v-icon class="ml-2" v-if="item.hidden" color="red">
            mdi-eye-off
          </v-icon>
          <v-icon v-else class="ml-2" color="grey">
            mdi-eye-outline
          </v-icon>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" color="primary" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon color="red" @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../mixins/validationRules";
export default {
  mixins: [validationRules],
  data() {
    return {
      dialog: false,
      search: "",
      editorials: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        country: "",
        hidden: false,
        featured: false
      },
      defaultItem: {
        name: "",
        country: "",
        hidden: false,
        featured: false
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("title.newItem")
        : this.$t("title.editItem");
    },
    headers() {
      return [
        {
          text: this.$t("name"),
          value: "name"
        },
        {
          text: this.$t("table.country"),
          value: "country"
        },
        {
          text: "Slug",
          value: "slug"
        },
        {
          text: this.$t("table.hidden"),
          value: "hidden"
        },
        {
          text: this.$t("table.featured"),
          value: "featured"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          width: "12%",
          align: "end",
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/editorial";
      axios
        .get(path)
        .then(response => {
          this.editorials = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.editorials.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    newItem() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/editorial/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.editorials.indexOf(item);
            this.editorials.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        if (index > -1) {
          path =
            this.$store.state.endpoint + "/editorial/" + this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              Object.assign(this.editorials[index], response.data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/editorial";
          const data = this.editedItem;
          axios
            .post(path, data)
            .then(response => {
              this.editorials.push(response.data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
